import types from 'redux/types';

export const getAllGamesAction = (teamId, leagueId) => ({
  type: types.GET_GAMES_START,
  // College payloads are passed as { teamId, leagueId } objects already
  // (see Header.jsx) and route to getCollegeSchedule in the saga below,
  // keyed off `typeof payload === 'object'`. For the regular (non-college)
  // path, payload stays the plain scalar team id so that branch is
  // unaffected; leagueId travels as a separate action property instead.
  payload: teamId,
  leagueId: typeof teamId === 'object' ? undefined : leagueId,
});

// League-wide "Upcoming Events" fetch, routed through the same
// GET_GAMES_START/takeLatest saga as getAllGamesAction (src/redux/games/
// actions.js) rather than a raw axios .then() - a manually-dispatched
// GET_GAMES_SUCCESS bypasses takeLatest's cancellation, so if this and a
// team-scoped fetch land close together, whichever response arrives last
// silently overwrites the other in the shared games.data slice regardless
// of which one the current URL actually calls for.
export const getUpcomingGamesAction = (leagueId) => ({
  type: types.GET_GAMES_START,
  leagueId,
  isUpcoming: true,
});

export const allGamesResetAction = () => ({
  type: types.GET_GAMES_RESET,
  payload: [],
});

export const setAllGamesInfo = () => ({
  type: types.GET_GAMES_SUCCESS,
});
